import {Modal} from 'react-bootstrap'
import Swal from 'sweetalert2'
import {MutationSetCupom} from '../../../graphql'
import {FormInputAndLabel} from '../../../../components/UI/Inputs/FormInputAndLabel'
import {ErrorMessageComponent} from '../../../components/UI/ErrorMessage'
import {useEffect, useState} from 'react'
import {FormInputMaskAndLabel} from '../../../../components/UI/Inputs/FormInputMaskAndLabel'
import {addLaunchesPartners} from '../../../../../services/urbit-gis'
import {useForm} from 'react-hook-form'
import {IncorporadoraUpdateFormData, IncorporadoraUpdateFormSchema} from './formValidations'
import {zodResolver} from '@hookform/resolvers/zod'
import ImageDropzone from '../../../components/DropzoneImage'

interface situacaoTerrenoProps {
  closeModal: any
  show: boolean
}

export function CreateForm({closeModal, show}: situacaoTerrenoProps) {
  const [loading, setLoading] = useState(true)
  const [image, setImage] = useState('')
  const {
    reset,
    handleSubmit,
    register,
    formState: {errors},
  } = useForm<IncorporadoraUpdateFormData>({
    resolver: zodResolver(IncorporadoraUpdateFormSchema),
  })
  const onSubmit = async (data) => {
    const formData = new FormData()
    formData.append('file', image)
    formData.append('nome', data.nome)
    formData.append('type', 'developer')

    let message = ''

    // Mostrar Swal de loading
    Swal.fire({
      title: 'Enviando Informações...',
      text: 'Por favor, aguarde.',
      icon: 'info',
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })
    const token = localStorage.getItem('token')
    await fetch(process.env.REACT_APP_API_GIS + `real_estate_launches_partners/add`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        message =
          result.service !== 'error'
            ? 'Incoporadora adicionado com sucesso.'
            : result.message || 'Houve um erro ao adicionar a Incoporadora.'

        Swal.fire({
          title: result.service !== 'error' ? 'Sucesso!' : 'Erro!',
          text: message,
          icon: result.service !== 'error' ? 'success' : 'error',
          confirmButtonText: 'OK',
        }).then((result) => {
          closeModal()
        })
      })
  }

  return (
    <Modal centered animation show={show} onHide={() => closeModal()}>
      <Modal.Header closeButton>
        <Modal.Title>Nova Incorporadora:</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='row'>
            <div className='col-md-12'>
              <div className='mb-6'>
                <FormInputAndLabel
                  label='Codigo'
                  className='form-control required form-control-solid'
                  placeholder='Nome'
                  defaultValue={''}
                  register={register('nome')}
                  error={errors ? errors.nome?.message : ''}
                />
              </div>
            </div>
            <div className='col-md-12'>
              <ImageDropzone value={image} setImage={setImage} register={register('logo')} />
            </div>
            <div className='col-md-12 py-6 d-flex' style={{justifyContent: 'flex-end'}}>
              <button
                className='btn btnSecondary  pull-right '
                type='button'
                onClick={() => closeModal()}
              >
                Fechar
              </button>
              <button type='submit' className='btn btn-success mx-2'>
                Salvar
              </button>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}
